@if(dataVisible$ | async) {
  <form [formGroup]="formGroup">
    @if (formGroup.controls.winstUitOnderneming.value ?? 0 !== 0) {
      <div class="row">
        <div class="col col-1">
          Winst uit onderneming
        </div>
        <div class="col-2">
          <snelstart-ui-number-form-control
            [decimals]="0"
            align="right"
            class="custom-input-150"
            formControlName="winstUitOnderneming"
            id="winstUitOnderneming"
            prefix="€"
          ></snelstart-ui-number-form-control>
        </div>
        <div class="col-3"></div>
        <div class="col-4"></div>
      </div>
    }
    @if (formGroup.controls.belastbaarloon.value ?? 0 !== 0) {
      <div class="row">
        <div class="col col-1">
          Loon uit dienstbetrekking
        </div>
        <div class="col-2">
          <snelstart-ui-number-form-control
            [decimals]="0"
            align="right"
            class="custom-input-150"
            formControlName="belastbaarloon"
            id="belastbaarloon"
            prefix="€"
          ></snelstart-ui-number-form-control>
        </div>
        <div class="col-3"></div>
        <div class="col-4"></div>
      </div>
    }
    @if (formGroup.controls.resultaatUitOverigeWerkzaamheden.value ?? 0 !== 0) {
      <div class="row">
        <div class="col col-1">
          Resultaat uit overige werkzaamheden
        </div>
        <div class="col-2">
          <snelstart-ui-number-form-control
            [decimals]="0"
            align="right"
            class="custom-input-150"
            formControlName="resultaatUitOverigeWerkzaamheden"
            id="resultaatUitOverigeWerkzaamheden"
            prefix="€"
          ></snelstart-ui-number-form-control>
        </div>
        <div class="col-3"></div>
        <div class="col-4"></div>
      </div>
    }
    @if (formGroup.controls.periodiekeUitkeringen.value ?? 0 !== 0) {
      <div class="row">
        <div class="col col-1">
          Periodieke uitkeringen en verstrekkingen
        </div>
        <div class="col-2">
          <snelstart-ui-number-form-control
            [decimals]="0"
            align="right"
            class="custom-input-150"
            formControlName="periodiekeUitkeringen"
            id="periodiekeUitkeringen"
            prefix="€"
          ></snelstart-ui-number-form-control>
        </div>
        <div class="col-3"></div>
        <div class="col-4"></div>
      </div>
    }
    @if (formGroup.controls.inkomstenUitEigenWoning.value ?? 0 !== 0) {
      <div class="row">
        <div class="col col-1">
          Inkomen uit eigen woning
        </div>
        <div class="col-2">
          <snelstart-ui-number-form-control
            [decimals]="0"
            align="right"
            class="custom-input-150"
            formControlName="inkomstenUitEigenWoning"
            id="inkomstenUitEigenWoning"
            prefix="€"
          ></snelstart-ui-number-form-control>
        </div>
        <div class="col-3"></div>
        <div class="col-4"></div>
      </div>
    }
    @if (formGroup.controls.aftrekWegensGeenOfGeringeEigenWoningSchuld.value ?? 0 !== 0) {
      <div class="row">
        <div class="col col-1">
          Aftrek geen of geringe eigen woning schuld
        </div>
        <div class="col-2">
          <snelstart-ui-number-form-control
            [decimals]="0"
            align="right"
            class="custom-input-150"
            formControlName="aftrekWegensGeenOfGeringeEigenWoningSchuld"
            id="aftrekWegensGeenOfGeringeEigenWoningSchuld"
            prefix="€"
          ></snelstart-ui-number-form-control>
        </div>
        <div class="col-3"></div>
        <div class="col-4"></div>
      </div>
    }
    @if (formGroup.controls.uitgavenVoorInkomensvoorzieningen.value ?? 0 !== 0) {
      <div class="row">
        <div class="col col-1">
          Uitgaven voor inkomensvoorzieningen
        </div>
        <div class="col-2">
          <snelstart-ui-number-form-control
            [decimals]="0"
            align="right"
            class="custom-input-150"
            formControlName="uitgavenVoorInkomensvoorzieningen"
            id="uitgavenVoorInkomensvoorzieningen"
            prefix="€ -"
          ></snelstart-ui-number-form-control>
        </div>
        <div class="col-3"></div>
        <div class="col-4"></div>
      </div>
    }
    @if (formGroup.controls.negatieveUitgavenVoorInkomensvoorzieningen.value ?? 0 !== 0) {
      <div class="row">
        <div class="col col-1">
          Negatieve uitgaven voor inkomensvoorzieningen
        </div>
        <div class="col-2">
          <snelstart-ui-number-form-control
            [decimals]="0"
            align="right"
            class="custom-input-150"
            formControlName="negatieveUitgavenVoorInkomensvoorzieningen"
            id="negatieveUitgavenVoorInkomensvoorzieningen"
            prefix="€"
          ></snelstart-ui-number-form-control>
        </div>
        <div class="col-3"></div>
        <div class="col-4"></div>
      </div>
    }
    @if (formGroup.controls.negatievePersoonsgebondenAftrek.value ?? 0 !== 0) {
      <div class="row">
        <div class="col col-1">
          Negatieve persoonsgebonden aftrek
        </div>
        <div class="col-2">
          <snelstart-ui-number-form-control
            [decimals]="0"
            align="right"
            class="custom-input-150"
            formControlName="negatievePersoonsgebondenAftrek"
            id="negatievePersoonsgebondenAftrek"
            prefix="€"
          ></snelstart-ui-number-form-control>
        </div>
        <div class="col-3"></div>
        <div class="col-4"></div>
      </div>
    }
    @if (formGroup.controls.overigeInkomsten.value ?? 0 !== 0) {
      <div class="row">
        <div class="col col-1">
          Overige inkomsten
        </div>
        <div class="col-2">
          <snelstart-ui-number-form-control
            [decimals]="0"
            align="right"
            class="custom-input-150"
            formControlName="negatievePersoonsgebondenAftrek"
            id="negatievePersoonsgebondenAftrek"
            prefix="€"
          ></snelstart-ui-number-form-control>
        </div>
        <div class="col-3"></div>
        <div class="col-4"></div>
      </div>
    }
    @if (formGroup.controls.verrekendVerlies.value ?? 0 !== 0) {
      <div class="row">
        <div class="col col-1">
          Overige inkomsten
        </div>
        <div class="col-2">
          <snelstart-ui-number-form-control
            [decimals]="0"
            align="right"
            class="custom-input-150"
            formControlName="negatievePersoonsgebondenAftrek"
            id="negatievePersoonsgebondenAftrek"
            prefix="€ -"
          ></snelstart-ui-number-form-control>
        </div>
        <div class="col-3"></div>
        <div class="col-4"></div>
      </div>
    }
    <div class="row">
      <div class="col col-1">
        Inkomen uit werk en woning
      </div>
      <div class="col-2">
        <snelstart-ui-number-form-control
          [decimals]="0"
          align="right"
          class="custom-input-150"
          formControlName="inkomen"
          id="inkomen"
          prefix="€"
        ></snelstart-ui-number-form-control>
      </div>
      <div class="col-3"></div>
      <div class="col-4"></div>
    </div>
    <div class="row">
      <div class="col col-1">
        Verrekende persoonsgebonden aftrek
      </div>
      <div class="col-2">
        <snelstart-ui-number-form-control
          [decimals]="0"
          align="right"
          class="custom-input-150"
          formControlName="persoonsgebondenAftrek"
          id="persoonsgebondenAftrek"
          prefix="€ -"
        ></snelstart-ui-number-form-control>
      </div>
      <div class="col-3"></div>
      <div class="col-4"></div>
    </div>
    <div class="row">
      <div class="col col-1">
        <b>Belastbaar inkomen uit werk en woning {{ isPartnerView ? 'partner' : 'aangever' }}</b>
      </div>
      <div class="col-2">
        <snelstart-ui-number-form-control
          [decimals]="0"
          align="right"
          class="custom-input-150"
          formControlName="belastbaarInkomen"
          id="belastbaarInkomen"
          prefix="€"
        ></snelstart-ui-number-form-control>
      </div>
      <div class="col-3"></div>
      <div class="col-4"></div>
    </div>
  </form>
}
